var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.videos),function(video){return _c('VideoRow',{key:video.id,attrs:{"video":video}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }